
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/navtabs",
      function () {
        return require("private-next-pages/components/navtabs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/navtabs"])
      });
    }
  